// extracted by css-extract-rspack-plugin
var _1 = "bKJvlwFLE6LTurmjkfUiAQ--";
var _2 = "PIdcDhlFUPnUuMth92N4sw--";
export { _1 as "badgeWrapper", _2 as "container" }
